/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	
	/**
	 * Created by costberg on 3/3/16.
	 */
	
	define('galileo/util/switchLocale',[],function() {
	    return function(locale, callback) {
	        if (window.global_page_viewer && window.global_page_viewer.encodedId) {
	            require(['galileo/util/loggedInSwitchLocale'], function(loggedInSwitchLocale) {
	                loggedInSwitchLocale(locale, window.global_page_viewer, callback);
	            });
	        } else {
	            $.post('/i18n/switch', {
	                    locale: locale,
	                    csrfToken: window.fitbitCsrfToken
	                },
	                callback);
	        }
	    }
	});}.call(window));

/***/ }
/******/ ])


/** WEBPACK FOOTER **
 ** switchLocale.js.98afd7043f045fd59a6caa62142d5f65.js
 **/